import(/* webpackMode: "eager" */ "/var/www/html/cliquefatos-headless/node_modules/next/dist/client/app-dir/link.js");
